export interface Contact {
  id: string;
  firstName: string;
  relationship: string;
  photo: string;
  photoAlt: string;
  info?: string;
}

export const CONTACTS: Contact[] = [
  {
    id: 'marie',
    firstName: 'Marie',
    relationship: 'Ma fille',
    photo: 'https://img.rocket.new/generatedImages/rocket_gen_img_1241c5efb-1763301638353.png',
    photoAlt: 'Marie, votre fille, femme souriante aux cheveux bruns',
    info: 'Dernier message reçu aujourd\'hui',
  },
  {
    id: 'jean',
    firstName: 'Jean',
    relationship: 'Mon fils',
    photo: 'https://img.rocket.new/generatedImages/rocket_gen_img_197dddd0a-1772774226548.png',
    photoAlt: 'Jean, votre fils, homme souriant aux cheveux courts',
    info: 'Disponible pour un appel',
  },
  {
    id: 'sophie',
    firstName: 'Sophie',
    relationship: 'Ma petite-fille',
    photo: 'https://img.rocket.new/generatedImages/rocket_gen_img_1afbed7af-1772227444596.png',
    photoAlt: 'Sophie, votre petite-fille, jeune femme souriante aux cheveux blonds',
    info: 'Sophie vous a envoyé une photo',
  },
  {
    id: 'paul',
    firstName: 'Paul',
    relationship: 'Mon frère',
    photo: 'https://img.rocket.new/generatedImages/rocket_gen_img_174f756e9-1766581221808.png',
    photoAlt: 'Paul, votre frère, homme aux cheveux gris souriant',
  },
  {
    id: 'claire',
    firstName: 'Claire',
    relationship: 'Mon amie',
    photo: 'https://img.rocket.new/generatedImages/rocket_gen_img_1809bdc1b-1772567547259.png',
    photoAlt: 'Claire, votre amie, femme souriante aux cheveux courts',
  },
];

export function getContact(id: string): Contact | undefined {
  return CONTACTS.find(c => c.id === id);
}

export const MAIN_CONTACTS = CONTACTS.slice(0, 3); // Marie, Jean, Sophie
